import { get } from "../../../services/request";

export const fetchMasterTimeZoneService = () => {
  return get("MasterTimeZone/GetAll");
};